<template>
  <el-dialog title="图片裁剪" :visible="visible" width="1000px" top="3vh" :before-close="onClose">
    <div>
      <ImageCropper ref="imageCropperRef" v-bind="$attrs" />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" @click="onOk">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import ImageCropper from '@/components/ImageCropper.vue'
import { debounce } from 'lodash-es'
export default {
  name: 'ImageCropperDialog',
  components: { ImageCropper },

  data() {
    return {
      visible: true
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },

    onOk: debounce(async function () {
      this.$emit('cropperFile', await this.$refs.imageCropperRef.cropImage(), this.$attrs.options)
    }, 500)
  }
}
</script>
<style scoped lang="scss"></style>
